(function FranchiseListReview($, Adzuki)
{
	"use strict";

	Adzuki.onload(['GroupCategories/add/', 'GroupCategories/edit/'], init);

	function init() {
		$('#groupcategorysave-ship_category_id').on('change', updateCategoryName);
		$('.occupancy_checkbox').on('change', toggleOccupancyType);
		$('.group-copy-link').on('click', copyPassengerPricing);

		$('.occupancy_checkbox').change();

		setAllLabels();

		$('.custom-label').on('change', function labelChange() {
			changeLabels(this);
		});

		$('.price-field').on('change', function _calculateTotal() {
			var occupancy = $(this).data('occupancy');
			var passenger = $(this).data('passenger');
			var total     = 0.00;

			$('.col-' + occupancy + '-' + passenger + ' .price-field').each(function _totalColumn() {
				if ($(this).val().length !== 0) {
					total = (total + parseFloat($(this).val()));
				}
			});

			$('.total-' + occupancy + '-' + passenger).html(formatCurrency(total));
		});
	}

	function formatCurrency(total) {
		var neg = false;

		return (neg ? "-$" : '$') + parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
	}

	function setAllLabels()
	{
		$(".custom-label").each(function labelChangeOnLoad() {
			changeLabels(this);
		});
	}

	function toggleOccupancyType(ev) {
		var occupancy_type = $(ev.currentTarget).data('occupancy_type');
		var section_id = '#' + occupancy_type + '-occupancy-pricing';

		if ($(ev.currentTarget).is(':checked')) {
			$(section_id).removeClass('hidden');
		} else {
			$(section_id).addClass('hidden');
		}
	}

	function updateCategoryName() {
		$('#groupcategorysave-name').val($(this).find('option:selected').html());
	}

	function copyPassengerPricing(ev) {
		var occupancy     = $(this).data('occupancy');
		var passenger     = parseInt($(this).data('passenger'));
		var copy_from     = passenger - 1;
		var field         = '';
		var copy_to_field = '';
		var total         = 0.00;

		// Get the passenger pricing fields based on the occupancy type and the passenger number we're copying from
		$('input[data-occupancy=' + occupancy +'][data-passenger=' + copy_from + ']').each(function copyPassengerField(index, el) {
			field         = $(el).data('field');
			copy_to_field = 'groupcategorysave-groupcomponentcategoryoccupancypassenger-' + occupancy + 'occupancy-' + field + '-' + (passenger - 1);

			$('#' + copy_to_field).val($(el).val());

			if ($(this).val().length !== 0) {
				total = (total + parseFloat($(this).val()));
			}
		});

		$('.total-' + occupancy + '-' + passenger).html(formatCurrency(total));

		ev.preventDefault();
	}


	// if the agent enters custom labels, change all of the occupancy pricing labels on the form for that type of field.
	function changeLabels(el)
	{
		var $self      = $(el),
		    custom_val = $self.val().trim(),
		    label_type = $self.data('custom-type'),
		    new_label  = '',
		    map        = [],
		    translation;

		map['gratuity']        = ['Gratuity', 'gratuities-label'];
		map['additional-fees'] = ['Additional Fees', 'additional_fees-label'];
		map['markup']          = ['Mark Up', 'mark_up-label'];
		translation            = map[label_type];

		if (custom_val.length > 0) {
			new_label = custom_val;
		} else {
			new_label = translation[0];
		}

		$('.' + translation[1]).html(new_label);
	}

}(jQuery, window.Adzuki || {}));
